const zh={
    name:'中文'
}
export default zh;